import './RenderDuration.css';
import RenderDuration from './RenderDuration';

export default RenderDuration;
